'use strict';

export default function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('main.group_report_show', {
    template: '<group-report-show></group-report-show>'
  }).state('main.group_report_show.detail', {
    url: 'group_report/:id',
    params: { term: null, target: null },
    views: {
      daily: {
        template: '<daily-group-report></daily-group-report>'
      },
      weekly: {
        template: '<weekly-group-report></weekly-group-report>'
      },
      monthly: {
        template: '<monthly-group-report></monthly-group-report>'
      },
      yearly: {
        template: '<yearly-group-report></yearly-group-report>'
      }
    }
  })
}



// WEBPACK FOOTER //
// ./public/dev/app/group_report/show/group_report_show.routes.js